import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { IAlert } from './shared.interfaces';
import { Constants } from './shared.constants';


@Injectable()
export class ComponentBase {

    alert: IAlert;

    constructor(public router: Router) {
    }

    protected _allowNavigate(): Promise<boolean> {

        return Promise.resolve(true);
    }

    protected _showAlert(type: string, msg: string): void {

        this.alert = {
            id: (new Date()).getTime().toString(),
            type: type,
            msg: msg,
            timeout: Constants.ALERT_TIMEOUT
        };
    }

    public allowNavigate(): Promise<boolean> {

        return this._allowNavigate();
    }

    protected _navigateTo404(): void {

        // navigate to not found
        this.router.navigate(['/404']);
    }


    // Giftcards

    protected _navigateToGiftcards(id: number): void {

        // navigate to list
        this.router.navigate(['/giftcards', id]);
    }

    protected _navigateToGiftcardDetails(id: number): void {

        // navigate to list
        this.router.navigate(['/giftcards', id]);
    }

    protected _navigateToGiftcardEdit(id: number): void {

        // navigate to edit
        this.router.navigate(['/giftcard', id]);
    }


    // Products

    protected _navigateToProducts(id: number): void {

        // navigate to list
        this.router.navigate(['/productos', id]);
    }

    protected _navigateToProductCreate(): void {

        // navigate to create
        this.router.navigate(['/producto']);
    }

    protected _navigateToProductDetails(id: number): void {

        // navigate to list
        this.router.navigate(['/productos', id]);
    }

    protected _navigateToProductEdit(id: number): void {

        // navigate to edit
        this.router.navigate(['/producto', id]);
    }

    // Categories

    protected _navigateToCategories(): void {

        // navigate to details
        this.router.navigate(['/categorias']);
    }

    protected _navigateToCategoryCreate(): void {

        // navigate to create
        this.router.navigate(['/categorias', 0]);
    }

    protected _navigateToCategoryDetails(id: number): void {

        // navigate to details
        this.router.navigate(['/categorias', id]);
    }


    // Companies

    protected _navigateToCompanies(): void {

        // navigate to list
        this.router.navigate(['/empresas']);
    }

    protected _navigateToCompanyCreate(): void {

        // navigate to create
        this.router.navigate(['/empresa']);
    }

    protected _navigateToCompanyDetails(id: number): void {

        // navigate to details
        this.router.navigate(['/empresas', id]);
    }

    // Coupons

    protected _navigateToCoupons(): void {

        this.router.navigate(['/cupones']);
    }

    protected _navigateToCouponDetails(id: number, showSend = false): void {

        this.router.navigate(['/cupon', id, showSend]);
    }


    // Givis

    protected _navigateToGivis(): void {

        // navigate to list
        this.router.navigate(['/givis']);
    }

    protected _navigateToGiviDetails(id: number): void {

        // navigate to details
        this.router.navigate(['/givi', id]);
    }


    // Users

    protected _navigateToUserDetails(id: number): void {

        // navigate to details
        this.router.navigate(['/usuarios', id]);
    }

    protected _navigateToMyAccount(id: number): void {

        // navigate to details
        this.router.navigate(['/billetera', id]);
    }

    protected _navigateToMyConfig(id: number): void {

        // navigate to details
        this.router.navigate(['/micuenta', id]);
    }


    protected _randomNumber(min: number, max: number): number {
        // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
}
